import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import StyleRules from "./StyleRules";
import "./index.css";

if (process.env.NODE_ENV === "development") {
  import("./devAccessibilityAudit");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StyleRules />
    <App />
  </React.StrictMode>
);
